import { useCallback } from "react";
import { useBindingOperations } from "./useBindingOperations.js";
import { useEnvironment } from "./useEnvironment.js";
import { useTreeRootId } from "./useTreeRootId.js";
const useGetEntityListSubTree = () => {
  const environment = useEnvironment();
  const getEntityListSubTree = useBindingOperations().getEntityListSubTree;
  const treeRootId = useTreeRootId();
  return useCallback(
    (parametersOrAlias, ...treeId) => getEntityListSubTree(parametersOrAlias, treeId.length === 0 ? treeRootId : treeId[0], environment),
    [environment, getEntityListSubTree, treeRootId]
  );
};
export {
  useGetEntityListSubTree
};
//# sourceMappingURL=useGetEntityListSubTree.js.map
